import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WritableDraft } from "immer/dist/internal";

export enum PolicyEditPanelType {
  AddTemplate = "AddTemplate",
  EditCriteria = "EditCriteria",
  TemplateProperties = "TemplateProperties",
}

export interface IPolicyEditPanelManagementState {
  openedPanel: PolicyEditPanelType | null;
}

const initialState: IPolicyEditPanelManagementState = {
  openedPanel: null,
};

/* eslint no-param-reassign: "error" */
const policyEditPanelManagementSlice = createSlice({
  name: "policyEditPanelManagement",
  initialState,
  reducers: {
    openPanel: (state: WritableDraft<IPolicyEditPanelManagementState>, action: PayloadAction<PolicyEditPanelType>) => {
      state.openedPanel = action.payload;
    },
    closePanel: (state: WritableDraft<IPolicyEditPanelManagementState>) => {
      state.openedPanel = null;
    },
  },
});

export const policyEditPanelManagementActions = policyEditPanelManagementSlice.actions;
export { policyEditPanelManagementSlice };
export default policyEditPanelManagementSlice.reducer;